import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App.tsx";
import LocalApp from "./LocalApp.tsx";
import { WorkspaceProvider } from "./context/WorkspaceContext";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        {/* /local route — standalone, no WorkspaceProvider needed */}
        <Route path="/local" element={<LocalApp />} />

        {/* All other routes need the Workspace (CefSharp) context */}
        <Route
          path="*"
          element={
            <WorkspaceProvider>
              <Routes>
                <Route path="/qa/:slug" element={<App />} />
                <Route path="*" element={<App />} />
              </Routes>
            </WorkspaceProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
